import { call, put, takeLatest } from 'redux-saga/effects';

import { getLiteObject } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getLiteObject, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* liteObjectsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
